import PullBatchableQueue from './PullBatchableQueue';
import { ResilienceMechanism } from './types';
// Enum isnt just a type, its also an object that needs to be
// exported as an object.
export { ResilienceMechanism };
export default ((retryQueuePrefix, product, options, logger) => {
  return new PullBatchableQueue(retryQueuePrefix, product, options || {}, logger);
});